import { Container } from "inversify";
import "reflect-metadata";
import RollingDataService from "src/components/home/parts/rolling-dataservice";
import ArtsDataService from "./components/arts/arts.data.service";
import HomeDataService from "./components/home/home.data.service";
import BlockchainService from "./services/blockchain.service";
import FileSystemService from "./services/filesystem.service";
import HttpService from "./services/http.service";
import IdentityService from "./services/identity.service";
import AdminService from "./services/admin.service";
import NumberProviderService from "./services/number_provider";
import PrivateFileSystem from "./services/private.filesystem.service";
import ToastService from "./services/toast.service";
import PaymentService from "./services/payment.service";

// Initialize DI/IoC container
const container = new Container();

// tslint:disable-next-line:no-empty

container.bind(HttpService).toSelf().inSingletonScope();
container.bind(HomeDataService).toSelf().inSingletonScope();
container.bind(ArtsDataService).toSelf().inSingletonScope();
container.bind(IdentityService).toSelf().inSingletonScope();
container.bind(AdminService).toSelf().inSingletonScope();
container.bind(ToastService).toSelf().inSingletonScope();
container.bind(FileSystemService).toSelf().inSingletonScope();
container.bind(PrivateFileSystem).toSelf().inSingletonScope();
container.bind(RollingDataService).toSelf().inSingletonScope();
container.bind(BlockchainService).toSelf().inSingletonScope();
container.bind(NumberProviderService).toSelf().inSingletonScope();
container.bind(PaymentService).toSelf().inSingletonScope();

// container.bind(TeamDataService).toSelf().inSingletonScope();

export { container };



// WEBPACK FOOTER //
// ./src/inversify.config.ts